import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { MultiTextField } from '@/components/functional/Form/MultiTextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { Text } from '@/components/ui/Typography/Body/Text';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { getLabelWithOrder } from '@/utils/format/text';
import { draftCheck, validateOfferAnswer, } from '@/utils/validate/resources/rfp/professional/rfpProOffer';
/**
 * コンサル案件提案 回答内容 入力フォーム
 */
export const RfpProOfferAnswerField = (props) => {
    const { className = '', name, orderNumber } = props;
    const label = useMemo(() => getLabelWithOrder('ご回答内容', orderNumber), [orderNumber]);
    return (_jsxs(FieldLabel, Object.assign({ childWrapClassName: 'flex flex-col gap-y-8', className: clsx(FIELD_DOM_CLASS_NAME, className), isRequired: true, labelText: label }, { children: [_jsx(Text, Object.assign({ className: 'flex flex-col gap-y-4', size: 'sm' }, { children: _jsx("div", { children: "\u4E0B\u8A18\u306E\u6B04\u306E\u9805\u76EE\u306B\u3064\u3044\u3066\u3001\u8FFD\u8A18\u3059\u308B\u5F62\u3067\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\uFF081,000\u6587\u5B57\u4EE5\u5185\uFF09" }) })), _jsx("span", Object.assign({ className: 'inline-flex flex-col' }, { children: _jsx(MultiTextField, { minRows: 4, name: name, parseEmptyValue: '', type: 'text', validate: draftCheck(validateOfferAnswer) }) }))] })));
};
